import React from 'react';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Text from 'components/Text';

import { cxHelpers } from 'util/className';

const { cx, cxEl } = cxHelpers('CheckAddressError');

const CheckAddressError = ({
  editMode,
  checkAddressErrorMessage,
  payrollAddressValidationRollout = false,
}) => {
  const currentError = checkAddressErrorMessage();

  if (currentError) {
    const className = `${editMode ? 'edit' : 'view'}-${currentError}`;

    return (
      <Box className={cx(className)} mt={editMode ? 12 : 4} vcenter>
        {editMode && (
          <Box vcenter>
            <FontAwesomeIcon
              className={cxEl(`icon-${className}`)}
              icon={faExclamationCircle}
              color="red"
            />
          </Box>
        )}
        {(!payrollAddressValidationRollout || editMode) && (
          <Box vcenter tcenter ml={editMode ? 4 : 0}>
            <Text
              className={cxEl(`text-${className}`)}
              fs={editMode ? 14 : 16}
              fw600={!editMode}
              red
              i18n={`team.employee_profile.employee_information.address_errors.${currentError}`}
            />
          </Box>
        )}
      </Box>
    );
  }

  return null;
};

CheckAddressError.propTypes = {
  editMode: PropTypes.bool.isRequired,
  checkAddressErrorMessage: PropTypes.func.isRequired,
};

export default CheckAddressError;
